import React from 'react';
// import 'bootswatch/dist/darkly/bootstrap.css';
import 'bootswatch/dist/minty/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../../app/App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TopNavbar from './TopNav';
import Footer from './Footer';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MarktTopNav from './MarktTopNav';
import { useInactivityCheck } from '../../hooks/useInactivityCheck';

const MarktLayout = () => {
  const useDarkMode = useSelector((state) => state.auth.useDarkMode);
  useInactivityCheck();

  return (
    <div className='App d-flex flex-column'>
      <MarktTopNav />
      {/*<div className='content-container flex-grow-1 d-flex align-items-center flex-column mt-3'>*/}
      <div className='container flex-grow-1 my-3'>
        <Outlet />
      </div>
      <Footer darkMode={useDarkMode} />
      <ToastContainer
        autoClose={1500}
        position={'top-right'}
        draggable={false}
        closeOnClick={true}
        theme={useDarkMode ? 'dark' : 'colored'}
      />
    </div>
  );
};

export default MarktLayout;
